import { LIGHT } from "./colors";
import { pxToRem, themeTypography } from "./typography";

export const createThemeVariable = (mode) => {
  const palettes = LIGHT;

  return {
    palette: palettes,
    typography: themeTypography,
    components: {
      MuiLink: {
        styleOverrides: {
          root: {
            cursor: "pointer",
          },
        },
      },
      MuiButton: {
        defaultProps: {
          disableRipple: true,
          disableElevation: true,
        },
        styleOverrides: {
          root: {
            fontSize: pxToRem(14),
            textTransform: "none",
          },
        },
        variants: [
          {
            props: { variant: "contained", color: "secondary" },
            style: {
              background: palettes.secondaryColor[200],
              "&:hover": {
                background: palettes.secondaryColor[300],
              },
            },
          },
        ],
      },

      MuiIconButton: {
        styleOverrides: {
          root: {
            color: palettes.icon,
          },
        },
      },
    },
  };
};
